export class CampaignAlreadyExistsException extends Error {
  constructor(message) {
    super(message);
  }
}

